import React, { useEffect } from 'react';

import { DefaultContentApiImpl } from 'src/logic/contents/impl/contents-api-impl';

type Tail<T extends Array<unknown>> = ((...t: T) => any) extends ((
	_: any,
	...tail: infer TT
) => unknown)
	? TT
	: [];

type ApiConstructionArgs = Tail<
	ConstructorParameters<typeof DefaultContentApiImpl>
>;

/**
 * コンテンツAPIを配置 / 削除するuser-defined hooks
 * @param props: API実装に渡すハンドラ群
 */
export const useContentsApi = (
	...[
		exitHandler,
		nextHander,
		previousHandler,
		toggleIndexHandler,
	]: ApiConstructionArgs
) => {
	useEffect(
		() => {
			new DefaultContentApiImpl(
				true,
				exitHandler,
				nextHander,
				previousHandler,
				toggleIndexHandler
			).setWindowsApi();

			return () => {
				DefaultContentApiImpl.unsetWindowApi();
			};
		},
		[exitHandler, nextHander, previousHandler, toggleIndexHandler]
	);
};

/**
 * ELearningContentsApiSetterのprops型
 */
export interface IELearningContentsApiSetterProps {
	exitHandler: ApiConstructionArgs[0];
	nextHandler: ApiConstructionArgs[1];
	previousHandler: ApiConstructionArgs[2];
	toggleIndexHandler: ApiConstructionArgs[3];

	/** childrenを封鎖 / React更新時にはVFCなどを使う */
	children?: never;
}

/**
 * コンテンツAPIを設定するための仮想コンポーネント。
 * Handlerを受け取って
 */
const ELearningContentsApiSetter: React.ComponentType<
	IELearningContentsApiSetterProps
> = ({
	exitHandler,
	nextHandler: nextHander,
	previousHandler,
	toggleIndexHandler,
}) => {
	useContentsApi(
		exitHandler,
		nextHander,
		previousHandler,
		toggleIndexHandler
	);
	// 実体は無し
	return null;
};
ELearningContentsApiSetter.displayName = 'ELearningContentsApiSetter';

export default ELearningContentsApiSetter;



// WEBPACK FOOTER //
// ./src/components/ELearningContentsApiSetter.tsx